import { render, staticRenderFns } from "./CampaignCardSendButton.vue?vue&type=template&id=3c03e477&scoped=true"
import script from "./CampaignCardSendButton.vue?vue&type=script&lang=js"
export * from "./CampaignCardSendButton.vue?vue&type=script&lang=js"
import style0 from "./CampaignCardSendButton.vue?vue&type=style&index=0&id=3c03e477&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c03e477",
  null
  
)

export default component.exports